import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { green, red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core";

import { Change } from "./types";

interface Props {
  type: Change["type"];
}

export default function ItemIcon(props: Props) {
  const { type } = props;
  const classname = useStyles();

  if (type === "added") {
    return <AddIcon className={classname.addedIcon} />;
  }

  if (type === "deleted") {
    return <RemoveIcon className={classname.removedIcon} />;
  }

  return <SwapHorizIcon className={classname.modifiedIcon} />;
}

const useStyles = makeStyles({
  addedIcon: {
    fontSize: 18,
    color: green[500],
    marginRight: 10,
  },
  removedIcon: {
    fontSize: 18,
    color: red[200],
    marginRight: 10,
  },
  modifiedIcon: {
    fontSize: 18,
    color: "#009ed2",
    marginRight: 10,
  },
});
